export enum PlaylistChanelEnum {
    VISUAL,
    AUDIO
}
